import { Grid, Paper, Typography, makeStyles } from "@material-ui/core";
import React from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { Select } from "../../Common/Select";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 40,
    marginBottom: 40
  },
  title: {
    ...theme.typography.subtitle2,
    marginBottom: 20
  }
}));

const PackageCommittee = ({
  title,
  setSelectedPackageCommittee,
  selectedPackageCommittee,
  packageCommitteOptions,
  disabled,
}) => {
  const {t} = useTranslation();
  const classes = useStyles();

  return (
    <Paper elevation={1} className={classes.root}>
      <Typography className={classes.title}>
        {title}
      </Typography>
      <Grid container alignItems="center" spacing={3}>
        <Grid item lg={12} xs={12} style={{marginTop: '12px'}}>
          
        <Select
          id="packageCommittee"
          options={packageCommitteOptions}
          value={selectedPackageCommittee}
          setValue={(value) => setSelectedPackageCommittee(value)}
          disabled={disabled}
        />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default withTranslation()(PackageCommittee);
